const fraudMapping = [
  {
    indicator: 'indicatorTallyTransaction',
    info: 'Account not Tally',
    details: 'Account debits/credits are not in sync with current balance',
  },
  {
    indicator: 'indicatorRtgs',
    info: 'Suspicious RTGS Transactions',
    details:
      'RTGS transactions have a minimum amount limit as prescribed by RBI',
  },
  {
    indicator: 'indicatorAtmWithdrawal',
    info: 'Suspicious ATM Withdrawals',
    details: 'Amount multiple of 100, or Amount > 20000.',
  },
  {
    indicator: 'indicatorSalaryOnHoliday',
    info: 'Suspicious Salary Credits on Holiday',
    details: 'Salary Credits on bank holidays',
  },
  {
    indicator: 'indicatorSalary',
    info: 'Suspicious Salary Credits',
    details: 'Suspicious Salary Credits',
  },
  {
    indicator: 'indicatorRoundFigureSalary',
    info: 'Suspicious Round Figure Salary Credits',
    details: 'Round Figure Salary Credit',
  },
  {
    indicator: 'indicatorBankHoliday',
    info: 'Transactions on Bank Holidays',
    details:
      'NEFT, RTGS and cheque deposit transactions cannot happen on Bank holidays',
  },
  {
    indicator: 'indicatorLowVintage',
    info: 'Account with Low Vintage',
    details:
      'Account opening date is available/fetched and account opening date is less than a year from the generated date of this report.',
  },
  {
    indicator: 'indicatorRotationOfMoney',
    info: 'Rotation of Money',
    details:
      'Cyclic deposit of funds into an account and withdrawal/transfer of funds to another account after getting promotional interest or bonus from a promotional scheme of a bank.',
  },
];

export default fraudMapping;
